<template>
  <div class="vue-flow__node-default custom-node-padding root-node">
    <div class="node-type-tag">Start Conversation</div>
    <div>{{ data.label !== undefined && data.label !== null && data.label !== '' ? data.label : 'We starts here!' }}</div>
    <div v-if="summaryText !== ''" class="node-description">
      {{ summaryText }}
    </div>
    <Handle type="source" :position="Position.Right" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

function trimText(value) {
  if (typeof value === 'string') {
    return value.trim();
  }
  return '';
}

function shortenText(value) {
  const text = trimText(value);
  if (text.length <= 90) {
    return text;
  }
  return `${text.slice(0, 87)}...`;
}

const summaryText = computed(() => {
  if (props.data === null || props.data === undefined) {
    return '';
  }
  const message = shortenText(props.data.message);
  if (message.length > 0) {
    return `Starts with: ${message}`;
  }
  return '';
});
</script>

<style scoped>
.root-node {
  background-color: #F9FAFB;
  border: 1px solid #D1D5DB;
  border-radius: 12px; 
  box-shadow: 0 4px 12px rgba(0,0,0,0.08); 
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  min-width: 280px; 
  max-width: 400px;
}
.node-type-tag {
  background-color: #6B7280;
  color: #FFFFFF; 
  font-size: 0.75rem; 
  padding: 4px 12px; 
  border-radius: 9999px; 
  margin-bottom: 10px; 
  display: inline-block;
  text-transform: uppercase;
  font-weight: 600; 
  border: none; 
}
.custom-node-padding {
  padding: 15px 20px;
}
.root-node > div:not(.node-type-tag):not(.node-description) {
  font-size: 0.9rem;
  color: #334155; 
  text-align: center;
}
.node-description {
  font-size: 0.8rem;
  color: #4B5563;
  margin-top: 8px;
  white-space: pre-wrap;
  background-color: #F3F4F6;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px dashed #D1D5DB;
  text-align: left;
  min-width: 240px;
}
</style> 